import BundleListTab from './BundleListTab';

export default BundleListTab;
